export const chessRequiredMsg = {
  numberOfEntrances: 'Укажите количество подъездов',
  numberOfFloors: 'Укажите количество этажей',
  numberOfFlats: 'Укажите количество квартир',
  differentFloorEntrance: 'Укажите номер подъезда',
  differentFloorNumOf: 'Укажите количество этажей',
  differentNumberOfFlatsEntrance: 'Укажите номер подъезда',
  differentNumberOfFlatsFloor: 'Укажите этаж',
  differentNumberOfFlats: 'Укажите количество квартир',
  officeEntrance: 'Укажите номер подъезда',
  officeFloor: 'Укажите этаж',
  numberOfOffices: 'Укажите количество офисов',
};